import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import UserProfile from "@/domain/entities/user/UserProfile";
import useGetUserAvatar from "@/hooks/useGetUserAvatar";

interface UserAvatarProps {
    user: UserProfile;
    className?: string;
}

const UserAvatar = ({ user, className }: UserAvatarProps) => {
    const { data: avatarUrl } = useGetUserAvatar(user.profile.email);

    return (
        <Avatar className={className}>
            {(user.photoURL || avatarUrl) && (
                <AvatarImage
                    alt={`${user.profile.displayName}'s profile`}
                    onError={(e) => {
                        console.error("Avatar image failed to load:", e);
                        e.currentTarget.style.display = "none";
                    }}
                    src={user.photoURL ?? avatarUrl!}
                />
            )}
            <AvatarFallback>{user.getInitials}</AvatarFallback>
        </Avatar>
    );
};

export default UserAvatar;
